import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/report/opportunity";

/**
 * 销售商机分析（报表）接口
 */
export default {
    /** 查询销售商机分析报表，支持按阶段/区域/部门过滤 */
    report: (data) => axios.get({url: `${PREFIX_URI}/report`, data}),
}
